import { TFunction } from 'i18next'
import * as Yup from 'yup'

export const buildYupLocale = (t: TFunction): void => {
  Yup.setLocale({
    mixed: {
      required: {
        key: 'field.error.required',
      },
    },
    string: {
      email: {
        key: 'field.error.invalid',
      },
      min: ({ min }: any) => ({ key: 'field.error.min.length', values: { count: min } }),
    },
  })
}
